import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles(theme => ({
  card: {
    height: '100%',
    overflow: 'visible'
  },
  content: {
    padding: theme.spacing(0, 2, 2),
    height: 'calc(100% - 64px)'
  },
  mapContainer: {
    position: 'relative',
    width: '100%',
    borderRadius: theme.shape.borderRadius,
    overflow: 'hidden'
  },
  map: {
    width: '100%',
    height: '100%'
  },
  loading: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '400px'
  },
  mapLoadingOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000
  }
}));
